
import {  Component,FormPageMixins,appConst } from "@/lib";
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import CustomsBox from "@/store/modules/shipment/declarecustoms/customsbox"
@Component
export default class CreateDeclareCustomsView extends FormPageMixins {
  model:DeclareCustoms = new DeclareCustoms();

  async created() {

            Object.assign(this.config,{
            getAction:"shipment/declarecustoms/get",
             labelWidth:220,
            pageTitleL:"Action.Edit",
            okAction:"shipment/declarecustoms/update",
            isRedirectIndex:true,
         
        })

  }
    get record(){ 
      var result=this.$store.state.shipment.declarecustoms.editDeclareCustoms;
         if (result.salesType == appConst.salesType.domesticSales) {
        result.currency = appConst.currency.RMB;
      } else if(!result.currency) {
        result.currency = appConst.currency.USD;
      }
      return result
    };
      //状态
  get businessGroupList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.businessGroup)
  }
    //状态
  get shippingTypeList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.shippingType)
  }
    get transactionList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.transaction)
  }
    get startPortList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.startPort)
  }
    get endPortList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.endPort)
  }
    get countryOfArrivalList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.countryOfArrival)
  }
    get tradingCountryList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.tradingCountry)
  }
    get paymentList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.payment)
  }
  get salesTypeList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.salesType)
  }

  //客户列表
  get customerList() {
  
    var tt=this.$store.state.system.customer.customerList;
    return tt
  }

        //发货人列表
  get senderList() {
    return this.$store.state.system.sender.senderList;
  }

        //箱型
  get boxTypeList() {
      return this.getCodeListByCategory(
      appConst.codeCategory.boxType)
  }
  get currencyList() {
    return this.getCodeListByCategory(appConst.codeCategory.currency)
  }

  // 收汇登记状态是否为确认中、已确认
  get incomeConfirming() {
    return this.model.customerConfirmStatus !== appConst.confirmStatus.toBeConfirmed;
  }
       back() {
     this.$router.push({ name: "declarecustoms.list" });
  }  
     openDeclareGroupInfo(value) {     
         this.$router.push({
      name: "declareCustoms.declareGroup",
      query: {id:value}
      ,
    });
    }
      get currentUser() {
    return this.$store.state.currentUser.session.user;
  }

  formatTotalVolume(value: string): string {
    if (!value && value !== '0') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    const fixed = num.toFixed(3);
    return fixed.endsWith('0') ? num.toFixed(2) : fixed;
  }

  parseTotalVolume(value: string): string {
    return (value || '').replace(/,/g, '');
  }
}

